import Banner from '@/components/Banner2/index.vue';
import Advantages from '@/components/Advantages/index.vue';
import Function from './components/Function.vue';
import Part from './components/Part.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  name: 'data-service-news',
  components: {
    Banner,
    Advantages,
    Function,
    Part,
    Appointment2
  },
  data() {
    return {
      imageUrl: require('@/assets/images/service/information/news-banner.png'),
      bannerTitle: '资讯',
      bannerText: '同花顺致力为行业提供专业的资讯服务，利用丰富的内容资源、可靠的内容技术能力，解决内容来源、加工审核、分发策略等问题，帮助客户搭建一整套的资讯运营体系。',
      adsList: [{
        img: require('@/assets/images/service/information/news-content.png'),
        title: '内容积累',
        desc: '专业的内容生产团队、良好的媒体合作渠道、同顺号媒体矩阵资源。'
      }, {
        img: require('@/assets/images/service/information/news-operate.png'),
        title: '运营经验',
        desc: '同花顺网站、APP等千万月活平台内容运营经验，成熟的内容选编分发策略。'
      }, {
        img: require('@/assets/images/service/information/news-technology.png'),
        title: '技术优势',
        desc: '基于同花顺先进的AI技术提供底层支撑，丰富的NLP、知识图谱、大数据等技术手段，提供高效稳定的对外服务。'
      }, {
        img: require('@/assets/images/service/information/news-bountiful.png'),
        title: '场景丰富',
        desc: '金融零售APP资讯频道、私域社区内容转化、统一资讯中心、资讯采集转发服务。'
      }]
    };
  }
};